// Mobile Modal Window

var windowWidth = $(window).innerWidth();
var mobileToggle = $("#toggle");
var mobile = $("#tablet-menu");
var newMobile = $("#mobile-menu")

if (windowWidth > 480) {
      mobile = $("#tablet-menu");
}else{
    mobile = $("#mobile-menu");
}

mobileToggle.click(function () {
  mobile.fadeIn();
    $("body")
      .css("top", -document.documentElement.scrollTop + "px")
      .addClass("noscroll");
    $(".header-wrapper").css("background-color", "#eaedfa");
});

$(".close-modal").click(function () {
  mobile.fadeOut();
  $("body")
    .css("top", -document.documentElement.scrollTop + "px")
    .removeClass("noscroll");
  $(".header-wrapper").css("background-color", "white");
});

$(document).ready(function(){
   setTimeout(function(){

         $(".overlay").css("display", 'none')

   },5);
});

